// Company user types as returned by the backend (see Backend Constant.js USER_TYPE).
const ROLE_LABELS = {
  3: 'Admin',
  4: 'Sub Admin'
};

export const getOwnerRoleLabel = (owner) => ROLE_LABELS[owner?.user_type] || '';

export default getOwnerRoleLabel;
